import React from "react";
import { remove } from "lodash/array";
import PropTypes from "prop-types";
import { Popover } from "react-bootstrap";
import classNames from "classnames";
import "./styles.scss";
import CheckboxWithLabel from "../../../CheckboxWithLabel";

const ColumnsPopover = props => {
  const {
    columnList,
    onChangeColumnsSelection,
    visibleColumns,
    classes,
  } = props;

  return (
    <Popover
      className={classNames("mydpd-column-popover", classes.popover)}
      {...props}
    >
      <Popover.Content>
        {columnList.map(column => (
          <div
            className={classNames(
              "mydpd-column-popover-list-item",
              classes.list
            )}
            key={column.id}
          >
            <CheckboxWithLabel
              key={column.id}
              className={"mydpd-column-popover-checkbox"}
              label={column.Header}
              value={column.id}
              {...column.getToggleHiddenProps()}
              onChange={event => {
                const { onChange } = column.getToggleHiddenProps();
                const newVisibleColumns = visibleColumns.map(
                  column => column.id
                );
                event.target.checked
                  ? newVisibleColumns.push(column.id)
                  : remove(newVisibleColumns, value => value === column.id);
                onChangeColumnsSelection(newVisibleColumns);
                onChange(event);
              }}
              disabled={column.isVisible && visibleColumns.length === 1}
            />
          </div>
        ))}
      </Popover.Content>
    </Popover>
  );
};

ColumnsPopover.defaultProps = {
  columnList: [],
  onChangeColumnsSelection: () => null,
};

ColumnsPopover.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.array,
  columnList: PropTypes.array,
  onChangeColumnsSelection: PropTypes.func,
  visibleColumns: PropTypes.array,
  classes: PropTypes.object,
};

export default ColumnsPopover;
